import {useEffect, useMemo, useState} from 'react';

import type {Container, ServiceIdentifier} from 'inversify';

import type {Destructible} from './types';

import {AppError} from '../errors/app';

export function useInjectMobxStore<
  TStore extends Record<string, any> & Partial<Destructible>,
>(container: Container, identifier: ServiceIdentifier<TStore>): TStore {
  const store = useMemo(
    () => container.get<TStore>(identifier),
    [container, identifier],
  );

  if (!store) {
    throw new AppError(`Store ${String(identifier)} not found in container`);
  }

  const [s] = useState(store);

  useEffect(() => {
    return () => {
      return s.destruct?.();
    };
  }, [s]);

  return s;
}
